/***
 * module naming rule
 * @Description Chinese language
 * example [level 1 route]_[level 2 route]_...
 */
export default {
    "common": {
        "submit": "提交",
        "defaultInput": "请输入",
        "cancel": "取消",
        "confirm": "确认",
        "loginTimeout": "未登录或者登录超时，请重新登录",
        "noData": "没有数据",
        "custom": "在线客服",
    },
    "member_account": {
        "balance": "余额",
        "recharge": "充值",
        "flowHistory": "流量历史",
        "purchaseRecord": "购买记录",
        "myData": "我的流量",
        "deviceManagement": "设备管理",
        "changePsd": "修改密码",
        "logout": "注销",
        "acBalance": "我的余额",
        "acFlow": "我的流量",
        "acDevice": "我的设备",
        "acOrder": "购买记录",
        "acDeviceOrder":"设备订单",
        "acFlowStatistics": "流量统计",
        "acSetting": "设置",
        "balanceInfo": "当前余额",
        "rechargeCode": "充值码",
        "enterRechargeCode": "请输入充值码",
        "gift": "赠送",
        "returnAccount": "退款至【我的余额】",
        "certification": "已认证",
        "noCertified": "未认证"
    },
    "modify_information": {
        "account": "账号",
        "name": "姓名",
        "identification": "证件号",
        "countryName": "常住地区",
        "id": "身份信息",
        "edit": "编辑",
        "complete": "完成",
        "placeholderFirstName": "请输入您的姓氏",
        "placeholderName": "请输入您的名字",
        "firstName": "姓氏",
        "lastName": "名字",
        "placeholderID": "请输入您的身份证/VISA卡/驾驶号",
        "isNull": "未填写",
        "onlyNumber": "只能输入数字或字母",
        "IDTip": "证件号只能输入数字或字母"
    },
    "member_modifyPassword": {
        "oldPsd": "旧密码",
        "newPsd": "新密码",
        "title": "修改密码",
        "submit": "修改密码",
        "setUp": "设置",
        "accountSetUp": "账户设置",
        "accountManage": "账户管理",
        "password": "密码",
        "forgetPassword": "忘记密码",
        "loginOut": "退出登录",
        "unsubscribe": "注销账户",
        "unsubscribeAfter": "账户注销后，您将放弃以下权益",
        "tip1": "通过活动赠送、代充值及充值码兑换的余额",
        "tip2": "未用完及赠送的流量套餐",
        "tip3": "注销前，请认真阅读",
        "ucloudlink": "《优克联账户注销须知》",
        "cancellation": "联系客服注销",
        "oldPsdNull": "旧密码不能为空",
        "newPsdNull": "新密码不能为空",
        "modifyPasswordSuccess": "修改密码成功"
    },
    "member_myDeviceOrder": {
        "title": "设备订单",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消订单"
        },
        "pending":"Pending Payment",
        "noData": "暂无设备订单，请到商店看看~",
        "noList": "没有数据~",
        "tryAgainLater": "请稍后再试",
    },
    "member_recharge": {
        "recharge": "充值",
        "rechargeAmount": "（选择充值金额）",
        "present": "赠送",
        "currentBalance": "当前余额",
        "payAmount": "充值金额",
        "unit": "¥",
        "pay": "确认支付",
        "alipay": "支付宝",
        "paypal": "PayPal",
        "operateMess": "操作提示",
        "giveMore": "赠送"
    },
    "member_equipmentManagement": {
        "noData": "没有设备？",
        "knowMore": "去了解一下",
        "bindDevice": "绑定设备",
        "placeholderIMEI": "请输入设备IMEI号",
        "placeholderPwd": "请输入设备初始PWD",
        "bindNow": "立即绑定",
        "myEquipment": "我的设备",
        "equipmentMunual": "设备手册",
        "dataBound": "解除绑定",
        "bindSuccess": "绑定成功",
        "unBindSuccess": "解绑成功",
        "imeiNull": "设备IMEI不能为空",
        "pwdNull": "设备初始PWD不能为空"
    },
    "member_flowRecords": {
        "record": "流量历史",
        "filter": "筛选",
        "trafficStatistics": "流量统计"
    },
    "member_balanceDetails": {
        "title": "购买记录",
        "filter": "筛选",
        "total": "合计",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消订单"
        }
    },
    "member_productBalanceDetails": {
        "remain": "剩余可用流量",
        "validTime": "有效时间",
        "coverage": "覆盖范围",
        "productIntro": "套餐描述",
        "buyTime": "购买时间",
        "unsubscribe": "退订",
        "buyTimeTips": "以上时间基于中国北京时间（GMT+8）",
        "unsubscribeTips": "退订成功，本次消费金额将退到我的余额里"
    },
    "users_login": {
        "loginPhone": "手机登录",
        "loginEmail": "邮箱登录",
        "register": "账号注册",
        "inputPhone": "请输入手机号码",
        "inputPassword": "请输入密码",
        "forgetPassword": "忘记密码",
        "login": "登录",
        "goToLogin": "去登录",
        "inputEmail": "请输入邮箱号",
        "smsCode": "短信验证码",
        "inputSMSCode": "请输入短信验证码",
        "noReceiveCode": "没收到验证码？",
        "resend": "重新发送",
        "nextStep": "下一步",
        "findByPhone": "通过手机找回",
        "findByEmail": "通过邮箱找回",
        "verifyByEmail": "请到邮箱验证",
        "sendEmailTo": "我们已发送一封电子邮件到",
        "findYourPassword": "请点击其中的链接，并按步骤操作来找回您的密码",
        "noReceiveEmail": "收不到邮件？请检查您的垃圾邮件和已删除邮件目录下是否有来自 glocalme@ucloudlink.com 的邮件。",
        "or": "或",
        "resetPassword": "重设密码",
        "oldFormat": "至少6个字符",
        "passwordFormat": "6-20个字符(字母、数字或符号的组合)",
        "completeLogin": "完成并登录",
        "resetPasswordSuc": "重设密码成功",
        "backToGlocalMe": "请回到 GlocalMe Connect 登录体验",
        "activeReminder": "账户未激活，请前往该邮箱，点击激活链接来完成您的账户注册。",
        "known": "知道了"
    },
    "users_register": {
        "registerPhone": "手机注册",
        "registerEmail": "邮箱注册",
        "hasAccount": "已有账号？",
        "agree": "我同意",
        "agreement": "用户协议",
        "and": "和",
        "policy": "隐私政策",
        "logoutNotice": "永久注销",
        "submit": "提交",
        "selectArea": "选择常住地区",
        "countryOrRegion": "国家/地区",
        "change": "更换",
        "defaultRegion": "中国内地",
        "AE": "阿拉伯联合酋长国",
        "search": "搜索热门国家/地区",
        "reminder": "温馨提示",
        "reminderTips": "选择【",
        "reminderTips2": "】作为常住地，可享受该地及周边的专享优惠。选定后将不可更改。确定选择吗？",
        "confirm": "确定",
        "cancel": "取消",
        "setPassword": "设置密码",
        "registerByEmail": "请点击其中的链接来完成您的账户注册。",
        "activeSuc": "激活成功",
        "activeing": "正在激活",
        "activeAgain": "再次激活",
        "activeFail": "激活失败",
        "verified": "我已验证",
        "registerSuccess": "注册成功"
    },
    "home": {
        "globalPackageCN": "全球畅享套餐",
        "globalPackageEN": "ENJOY THE BEST MOBILE DATA SERVICE EXPERIENCE YOU EVER HAVE",
        "userExperienceCN": "全球过百个合作伙伴",
        "userExperienceEN": "TOGETHER WE BUILD A BETTER USER EXPERIENCE",
        "loading": "",
        "update": "由于系统服务升级，您需要选择常住国家或地区后方可继续使用。",
        "reminderTips": "选择【",
        "reminderTips2": "】作为常住地，可享受我们即将为该地及周边推出的专享优惠；且账户余额将",
        "reminderTips3": "按汇率【",
        "reminderTips4": "】",
        "reminderTips5": "转换为【",
        "reminderTips6": "】显示。选定后将不可更改。确定选择吗？",
        "gotoPC":"电脑版"
    },
    "privacyPolicy" : {
        "changeDate" : "隐私条款变更公告",
        "changeContain": "我们的隐私条款已更新。",
        "changeContain2" : "我们非常重视您的隐私。因此我们制定了涵盖如何收集、使用、披露、转让以及存储您的信息的隐私政策。我们不会向任何第三方提供您的信息，除非得到您的授权。若我们将信息用于您未授权用途或目的，我们会事先再次征求您的同意。",
        "changeContain3" : "您可以阅读我们完整的<a href=\"/users/agreement\" target=\"_blank\">《用户协议》</a>和<a href=\"/users/privacy_policy\" target=\"_blank\">《隐私条款》</a>了解我们的承诺。",
        "noagree" : "不同意",
        "agree" : "同意",
    },
    "service": {
        "selectDevice": "选择设备",
        "company": "企业方案",
        "faqs": "常见问题",
        "afterSale": "售后政策",
        "manual": "操作手册",
        "safety": "安全措施",
        "coverage": "覆盖区域"
    },
    "purchase": {
        "buy": "购买",
        "online": "线上渠道",
        "offline": "线下门店",
        "distributor": "分销商",
        "shopAddress": "店铺地址",
        "shopTels": "联系电话"
    },
    "data_package": {
        "flowShop": "流量商城",
        "recommend": "为您推荐",
        "destination": "选择目的地",
        "searchDestination": "搜索目的地",
        "historySearch": "历史搜索",
        "clean": "清空",
        "more": "更多",
        "enjoyPackage": "畅享包",
        "commonPackage": "普通包",
        "include": "含",
        "areaPackage": "的跨区域包",
        "enjoyDay": "包天畅享",
        "enjoyMonth": "月畅享",
        "unlimited": "无限",
        "houxiansu": "后限速",
        "currentMonth": "当月失效",
        "currentDay": "当日失效",
        "immediately": "立即生效",
        "morrow": "次日生效",
        "nextMonth": "次月生效",
        "iDay": "天",
        "iDays": "天",
        "iMonth": "个月",
        "iMonths": "个月",
        "cxtcIMonth": "月",
        "antarctica": "热门",
        "asia": "亚洲",
        "european": "欧洲",
        "africa": "非洲",
        "northAmerica": "美洲",
        "southAmerica": "南美洲",
        "oceania": "大洋洲",
        "flow": "流量",
        "period": "有效期",
        "applicableArea": "适用区域",
        "useNotice": "使用须知",
        "cost": "需付金额",
        "order": "订购",
        "confirmPay": "确认支付",
        "infiniteFlow": "无限流量",
        "unsubscribe": "不可退订",
        "subscribe": "可退订",
        "payFailed": "支付失败",
        "paypalTips": "由于PayPal的认证机制，PayPal付款的信息可能会出现延迟"
    },
    "pay_result": {
        "orderSuccess": "订购成功",
        "chargeSuccess": "充值成功",
        "orderSucTips": "您购买的[ ",
        "orderSucTips2": " ]将在1分钟内到账，如长时间未到账，请咨询客服。",
        "orderSucTips3": "将在1分钟内到账，如长时间未到账，请咨询客服。",
        "packageName": "套餐名称",
        "chargeAmount": "充值金额",
        "payAmount": "支付金额",
        "back": "返回首页",
        "myFlow": "查看我的流量",
        "myBalance": "查看我的余额",
        "tryLater": "请稍后再试",
        "succeed": "已完成支付",
        "fail": "支付遇到问题，请重新下单",
        "backToShop": "回到商城首页",
        "successful": "交易成功",
        "rejected": "交易被拒绝，请联系您的银行",
        "unsuccessful": "交易失败，请重试",
        "referenceNumber": "订单编号",
    },
    "my_order": {
        "month": "月",
        "day": "日"
    },
    "member_myFlow": {
        "myFlow": "我的流量",
        "remainHighSpeedTraffic": "剩余高速",
        "validityPeriod": "有效期",
        "day": "天",
        "month": "月",
        "status": "状态",
        "invalidPackage": "失效套餐",
        "usageRule": "使用规则",
        "close": "收起",
        "queryInvalidPackage": "查看失效套餐",
        "mccList": "适用区域",
        "usageMess": "使用须知",
        "payAmount": "支付金额",
        "payTime": "购买时间",
        "effectiveTime": "有效时间",
        "validTime": "生效时间",
        "invalidTime": "失效时间",
        "flow": "流量",
        "remainingFlow": "剩余流量",
        "highSpeedTraffic": "高速流量",
        "remainHighSpeedTraffics": "剩余高速流量",
        "unsubscribe": "退订",
        "unsubscribed": "已退订",
        "isCancelPackage": "是否退订该套餐?",
        "actionTip1": "注：使用PayPal支付的订单会收取",
        "actionTip2": " 手续费用",
        "reBack": "退款至【我的余额】",
        "cancel": "取消",
        "cancelSuccess": "退订成功",
        "reBackBy": "退款已退至【我的余额】",
        "iKnow": "我知道了",
        "usageRule1": "畅享包优先使用",
        "usageRule2": "相同类型可用流量包默认按购买时间顺序使用",
        "usageRule3": "若畅享包高速流量用完，将自动切换普通包使用",
        "packageUsageRule": "套餐使用规则",
        "dicObj": {
            "notActivated": "未激活",
            "inUsing": "使用中",
            "useEnd": "已用完",
            "expire": "到期",
            "transfer": "已转移",
            "unsubscribe": "退订",
            "valid": "有效",
            "invalid": "无效",
            "currentMonth": "当月失效"
        },
        "to": " 至 ",
        "noData": "暂无流量套餐，请到商店看看~",
        "noList": "没有数据~",
        "accumulatedThisHour": "本小时累计",
        "accumulatedThisDay": "本天累计",
        "accumulatedThisMonth": "本月累计",
        "accumulatedThisYear": "本年累计",
        "accumulatedFlow": "累计流量",
        "flowDetail": "流量详情"
    },
    "select_area": {
        "destination": "选择目的地",
        "selectCountry": "选择热门国家/地区"
    },
    "footer": {
        "belongs": "您的账号属于",
        "comeTo": "您已来到",
        "site": "站点",
        "changeTips": "您的账号无法切换至其他站点",
        "changeTips2": "如需切换，请您注销登录",
        "switchWebsite": "您现在访问其他站点与您账号归属站点不一致，需要注销登录才能继续访问"
    },
    "cloud_sim": {
        "s1": {
            "content0": "GlocalMe® Inside 是 uCloudlink 创新推出的全球数据流量服务，通过内置 GlocalMe Connect APP于手机，用户即可享受由 CloudSIM 技术所带来的前所未有的数据连接体验。",
            "title1": "使用便捷",
            "content1": "得益于GlocalMe® Inside服务的全球覆盖，商旅人士可以便捷无忧地享用移动数据。",
            "title2": "智能选网",
            "content2": "GlocalMe® Inside的智能选网功能实时监测信号变化，弃劣择优，随时保证连接至优质的本地网络。",
            "title3": "本地资费",
            "content3": "GlocalMe® Inside与超过100个国家及地区建立了运营商合作伙伴关系，因而能够为用户带来公平的本地数据资费。",
            "title4": "信息安全",
            "content4": "相较公共Wi-Fi，GlocalMe® Inside的连接为用户提供了更高的安全与隐私保护。",
            "title5": "GlocalMe® Inside世界手机一机在手，通行全球"
        },
        "u2":{
            "title":'时尚之选U2',
            "title1_1":"一机在手 全球通行",
            "title1_2":"GlocalMe U2",
            "title2":"U2超舒适的握持感",
            "title3_1":"香槟金",
            "title3_2":"寒铁灰",
            "title4":"时尚轻薄 便于携带",
            "title5":"随时随地 畅想4G网络",
            "title6":"基本参数",
            "title7_1":"覆盖100+国家及地区",
            "title7_2":"GlocalMe零漫游上网服务覆盖5大洲，100多个国际及地区",
            "title7_3":"全球Wi-Fi随时随地，任性联网。",
        },
        "g3":{
            "title1_1":"漫游小怪兽",
            "title1_2":"GlocalMe全新旗舰G3",
            "title2_1":"出国旅游必备全球上网神器",
            "title3_1":"黑·寒铁灰边框",
            "title3_2":"白·香槟金边框",
            "title4_1":"覆盖100+国家及地区",
            "title4_2":"GlocalMe零漫游上网服务覆盖5大洲，100多个热门国家及地区",
            "title4_3":"无需插入SIM卡，随时随地，任性联网",
            "title4_4":"详见官网“覆盖区域”",
            "title5_1":"为你充电 上网不掉线",
            "title5_2":"电量可输出，为手机等终端设备充电",
            "title5_3":"5350mAh锂离子电池，续航长达15小时",
            "title5_4":"采用国际一线厂商一流电芯，安全有保障",
            "title6_1":"零漫游,畅享全球最优网络",
            "title6_2":"业内领先的云SIM卡技术 实时智能匹配当地最优网络",
            "title7_1":"有分享 才更快乐",
            "title7_2":"您的Wi-Fi可支持5人同时上网，智能手机、iPad、笔记本、可穿戴智能设备等均能连接使用",
            "title8_1":"APP管理 更高效",
            "title8_2":"可以通过APP随时随地查询流量、续费充值、购买套餐、修改个人信息；支付方式：微信支付、支付宝、银联支付、PayPal",
            "title8_3":"长按图片识别二维码下载APP",
            "title9_1":"4G网速，资费更灵活",
            "title9_2":"按流量收费:",
            "title9_3":"计费0.05€/MB，10€封顶，限速不限流量",
            "title9_4":"套餐收费:",
            "title9_5":"私人定制，流量计费更省心，详见流量商城",
            "title9_6":"数据更安全",
            "title9_7":"私人专属移动热点, 保护您的信息安全,",
            "title9_8":"防止掉入免费Wi-Fi的黑洞",
        },
        "p3": {
            "title1_1": "多彩生活，一定有一个属于你的颜色",
            "title1_2": "创新跟和谐并重的设计。源自对产品形状，材料与颜色的同步研发，各元素之间的彼此呼应，一同创造出类拔萃，意义非凡的智能手机",
            "title3": "通过CloudSIM技术实现，不再需要漫游和SIM卡。",
            "title4": "你和他们之间的距离只差\"我\"",
            "title5_1": "GlocalMe® Inside",
            "title5_2": "创新的全球数据流量服务，通过内置的GlocalMe® Connect APP，用户即可享受由CloudSIM技术带来的前所未有的数据连接体验",
            "title6_1": "等等，还有更多！",
            "title6_2": "我们服务包括",
        },
        "simbox": {
            "title": "多卡宝",
            "title1": "手机秒变多卡多待",
            "title2": "15大优势满足多卡管理需求",
            "title3": "让手机秒变多卡多待",
            "title4": "国际通话 0漫游费",
            "title5": "真4G，全网通",
            "title6_1": "7x24小时在线",
            "title6_2": "电话/短信不漏接",
            "title7": "方正精致，简约时尚",
        },
        "glocalme_wifi": {
            "title": "为什么选择GlocalMe Wi-Fi",
        },
        "glocalme_phone": {
            "title": "为什么选择GlocalMe世界机"
        }
    },
    "about": {
        "contact": "联系我们",
        "news": "新闻动态",
        "glocalme": "关于我们",
        "partnership": "寻求合作",
        "partnerships": "合作伙伴",
        "note": "为了让我们更了解您的合作意向，请填以下表格，我们会尽快与阁下联系！",
        "username": "姓名",
        "email": "邮箱",
        "company": "公司名称",
        "position": "职位",
        "phone": "电话",
        "demand": "详情",
        "success": "成功",
        "deviceType": "设备类型",
        "quantity": "产品数量",
        "address": "地址",
        "heard": "如何知道我们？",
        "agreement": "同意<a href=\"/users/privacy_policy\">《隐私政策》</a>和<a href=\"/users/agreement\">《用户协议》</a>，uCloudlink 将会通过电子邮件或手机号码与您取得联系"
    },
    "validate": {
        "isEmail": "邮箱格式",
        "isMobilePhone": "手机号码",
        "isChinaName": "中文姓名",
        "required": "必填哦",
        "format": "格式不对哦~",
        "min": "最少应该输入",
        "max": "最多可以输入",
        "char": "个字符哦",
        "equal": "输入不一致",
        "invalid": "您的输入含有非法字符，如 <>, >< 等",
        "digits" : "产品数量 5-100",
    },
	"newCreate": {
        "onlyForAE": "此设备仅常住地为阿联酋的用户使用",
        "purchaseTips": "此页面只提供英文内容"
    }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js